import GeoJSON from 'ol/format/GeoJSON';

import { getIdPortenToken, logout } from './authentication'
import { warn } from '../notify'

const debug = false;
const cancellable = {};
const ws = '/klimagasskalkulator_ws';

const mainCall = { cancel: () => console.log('Avbryter') };
export const cancelMain = () => mainCall.cancel(); // geoupload, calc

const pollEmissions = (id, main) => new Promise((resolve, reject) => {
  if (debug) console.log('poll');
  const popupCall = !main;
  const xhr = new XMLHttpRequest();
  if (popupCall) cancellable[id.cancel] = xhr;
  xhr.onload = () => {
    if (xhr.status >= 200 && xhr.status < 300) resolve(xhr.response.statusUrl);
    else {
      const ut = 'Kobling til ID-porten utløpte, logg deg inn på nytt';
      const generic = 'Server svarer ikke';
      const unauthorized = (xhr.status === 401);
      if (unauthorized) logout();
      reject({ status: xhr.status, statusText: unauthorized ? ut : generic });
    }
  };
  xhr.onerror = () => reject({ status: xhr.status, statusText: xhr.statusText });
  const rid = `request_id=${id.request}`;
  xhr.open('GET', `${ws}/calcPoll?${rid}`, true);
  xhr.responseType = 'json';
  xhr.setRequestHeader('Content-Type', 'application/json');
  getIdPortenToken().then(idPortenToken => {
    xhr.setRequestHeader('nibiotoken', idPortenToken);
    xhr.send();
    if (main) mainCall.cancel = () => {
      xhr.abort();
      reject({ status: xhr.status, statusText: 'Avbrutt' });
    };
  }).catch(e => console.log(`${e}, pålogging kreves`));
});

const statusEmissions = (url, id, main) => new Promise((resolve, reject) => {
  if (debug) console.log('status');
  const popupCall = !main;
  const xhr = new XMLHttpRequest();
  if (popupCall) cancellable[id.cancel] = xhr;
  xhr.onload = () => {
    if (xhr.status >= 200 && xhr.status < 300) {
      // console.log(popupCall, Object.keys(cancellable), id.cancel);
      if (mainCall.url === url || (popupCall && !cancellable[id.cancel]))
        reject({ statusText: 'Avbrutt' });
      else if (xhr.response.status === 'FAILED') reject({ statusText: 'Feil' });
      else if (xhr.response.status === 'DONE') resolve(xhr.response.resultUrl);
      else setTimeout(() =>
        statusEmissions(url, id, main)
        .then(r => resolve(r))
        .catch(e => reject(e))
      , 1000);
    } else {
      const ut = 'Kobling til ID-porten utløpte, logg deg inn på nytt';
      const generic = 'Server svarer ikke';
      const unauthorized = (xhr.status === 401);
      if (unauthorized) logout();
      reject({ status: xhr.status, statusText: unauthorized ? ut : generic });
    }
  };
  xhr.onerror = () => reject({ status: xhr.status, statusText: xhr.statusText });
  xhr.open('GET', url, true);
  xhr.responseType = 'json';
  xhr.setRequestHeader('Content-Type', 'application/json');
  getIdPortenToken().then(idPortenToken => {
    xhr.setRequestHeader('nibiotoken', idPortenToken);
    xhr.send();
    if (main) mainCall.cancel = () => {
      xhr.abort();
      reject({ status: xhr.status, statusText: 'Avbrutt' });
      mainCall.url = url;
    };
  }).catch(e => console.log(`${e}, pålogging kreves`));
});

// Promise request: https://stackoverflow.com/a/30008115
export const getEmissions = (id, main) => new Promise((res, rej) => {
  // console.log(id);
  pollEmissions(id, main).then(url => statusEmissions(url, id, main))
  // .catch(() => rej({ statusText: 'Avbrutt' }))
  .then(url => {
    if (debug) console.log('result');
    const popupCall = !main;
    const xhr = new XMLHttpRequest();
    // xhr.responseType = 'json';
    if (popupCall) cancellable[id.cancel] = xhr;
    xhr.onloadend = () => delete cancellable[id.cancel];
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300)
        res(JSON.parse(xhr.responseText));
      else {
        const ut = 'Kobling til ID-porten utløpte, logg deg inn på nytt';
        const generic = 'Server svarer ikke';
        const unauthorized = (xhr.status === 401);
        if (unauthorized) logout();
        rej({ status: xhr.status, statusText: unauthorized ? ut : generic });
      }
    };
    xhr.onerror = () => rej({ status: xhr.status, statusText: xhr.statusText });
    xhr.open('GET', url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    getIdPortenToken().then(idPortenToken => {
      xhr.setRequestHeader('nibiotoken', idPortenToken);
      xhr.send();
      if (main) mainCall.cancel = () => {
        xhr.abort();
        rej({ status: xhr.status, statusText: 'Avbrutt' });
      };
    }).catch(e => console.log(`${e}, pålogging kreves`));
  }).catch(e => rej(e));
});

// Promise request: https://stackoverflow.com/a/30008115
const sendToBackend = (data, main, id) => new Promise((resolve, reject) => {
  const popupCall = !main;
  if (cancellable[id]) cancellable[id].abort(); // on drawing modification
  const xhr = new XMLHttpRequest();
  if (popupCall) cancellable[id] = xhr;
  xhr.onload = () => {
    if (xhr.status >= 200 && xhr.status < 300) {
      // reject({ status: xhr.status, statusText: 'fake unauthorized' });
      const r = xhr.response;
      if (r.delCount && r.delCount > 0) warn(
        `${r.delCount} flate(r) ligger utenfor lovlig område og ble ignorert`
      );
      if (r.invalidCount && r.invalidCount > 0) warn(
        `${r.invalidCount} ugyldige geometrier ble ignorert`
      );
      resolve({ request: r.requestId, cancel: id });
    } else {
      delete cancellable[id];
      // reject({ status: xhr.status, statusText: xhr.statusText });
      const ut = 'Kobling til ID-porten utløpte, logg deg inn på nytt';
      const generic = 'Server svarer ikke';
      const unauthorized = (xhr.status === 401);
      if (unauthorized) logout();
      reject({ status: xhr.status, statusText: unauthorized ? ut : generic });
    }
  };
  xhr.onerror = () => {
    reject({ status: xhr.status, statusText: xhr.statusText });
  };
  xhr.open('POST', `${ws}/geoupload`, true);
  xhr.responseType = 'json';
  xhr.setRequestHeader('Content-Type', 'application/json');
  getIdPortenToken().then(idPortenToken => {
    xhr.setRequestHeader('nibiotoken', idPortenToken);
    xhr.send(data);
    if (main) mainCall.cancel = () => {
      xhr.abort();
      reject({ status: xhr.status, statusText: 'Opplasting avbrutt' });
    };
  }).catch(e => console.log(`${e}, pålogging kreves`));
});

export const sendFeaturesToBackend = (features, main) => {
  if (!debug && features.length === 0) return new Promise(() => '');
  // console.log('Sending geojson to back-end to get table back');

  // Write features to GeoJSON:
  const format = new GeoJSON();
  const geojson = !debug ? format.writeFeatures(features)
    : `{"type":"FeatureCollection","features":[{"type":"Feature","geometry":
    {"type":"Polygon","coordinates":[[[253729.62909063228,6622401.821298759],
    [253723.9432004237,6622284.312901115],[253823.4462790738,6622328.852374416],
    [253729.62909063228,6622401.821298759]]]},"properties":{"id":"571","title":
    "Område A","plankategori":"Nåværende","arealformål":"1001","komid":"3022"},
    "id":"571"}]}`
  ;
  return sendToBackend(geojson, main, features.map(f => f.ol_uid).join('|'));
};

export const cancelAllPopupCalls = () => {
  Object.entries(cancellable).forEach(([k, v]) => {
    // console.log(k, v.readyState, v.status, v.statusText);
    if (v.readyState < 4) { v.abort(); delete cancellable[k]; }
    else console.log('It should have been deleted already!');
  });
};
